var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2"},[_c('div',{staticClass:"v-list__tile__sub-title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"subtitle-1 font-weight-normal"},[_vm._t("default",[_vm._v("\n      "+_vm._s(_vm.content)+"\n    ")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }